module.exports = __webpack_public_path__ + "static/media/45deg_sliding.830cb7d1.png";